import { render } from "./GoogleLoader.vue?vue&type=template&id=2942e850&scoped=true"
import script from "./GoogleLoader.vue?vue&type=script&lang=js"
export * from "./GoogleLoader.vue?vue&type=script&lang=js"

import "./GoogleLoader.vue?vue&type=style&index=0&id=2942e850&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2942e850"

export default script